module.exports = "/_next/static/images/127a52017249ebbedf5184be0ca14af1-nubanker-xpeer@3x.jpg.webp";